export default "__VITE_PUBLIC_ASSET__a593b199__"